'use client';

import type {
  CompanyBasicResponse,
  CompanyGesellschafterResponse,
  CompanyRegisterResponse,
} from '@/lib/backend-api';
import type { useSession } from '@/hooks/use-session';
import type { CompanyProfileHeroData } from './CompanyProfileSection';
import { RegisterDocsCard } from './RegisterDocsCard';
import { MOBILE_ORDER, REGISTER_DOCS_ANCHOR } from './companyDetailLayout';

interface CompanyDetailRegisterDocsProps {
  effectiveRegisterData: CompanyRegisterResponse | null;
  registerDocumentsSource: CompanyRegisterResponse | CompanyGesellschafterResponse | null;
  gesellschafterData: CompanyGesellschafterResponse | null;
  basicData: CompanyBasicResponse | null;
  hasGesellschafterliste: boolean;
  euId: string;
  session: ReturnType<typeof useSession>['data'];
  loadingRegister: boolean;
  loadingGesellschafter: boolean;
  heroData: CompanyProfileHeroData;
  showRegisterAttribution: boolean;
  attributionRegisterId: string | null;
}

export function CompanyDetailRegisterDocs({
  effectiveRegisterData,
  registerDocumentsSource,
  gesellschafterData,
  basicData,
  hasGesellschafterliste,
  euId,
  session,
  loadingRegister,
  loadingGesellschafter,
  heroData,
  showRegisterAttribution,
  attributionRegisterId,
}: CompanyDetailRegisterDocsProps) {
  return (
    <RegisterDocsCard
      className={MOBILE_ORDER.registerDocs}
      id={REGISTER_DOCS_ANCHOR}
      registerFiles={effectiveRegisterData?.register_files ?? []}
      registerDocuments={registerDocumentsSource?.register_documents}
      registerDocumentsComplete={
        registerDocumentsSource?.register_documents_complete
      }
      dkRegisterFile={
        gesellschafterData?.dk_register_file ??
        basicData?.register_files?.find(
          (f) => f.file_type === 'HandelsRegisterDKGesellschafter',
        ) ??
        null
      }
      hasGesellschafterliste={hasGesellschafterliste}
      rechtsformCode={
        effectiveRegisterData?.rechtsform_code ??
        basicData?.rechtsform_code
      }
      gruendungsdokument={
        effectiveRegisterData?.gruendungsdokument ??
        basicData?.gruendungsdokument
      }
      ersteEintragungDatum={
        effectiveRegisterData?.erste_eintragung_datum ??
        basicData?.erste_eintragung_datum
      }
      euId={euId}
      isAuthenticated={!!session}
      isRegisterLoading={loadingRegister && !!session}
      isGesellschafterLoading={loadingGesellschafter && !!session}
      isDeleted={heroData.isDeleted}
      showRegisterAttribution={showRegisterAttribution}
      registerCourt={basicData?.register_court}
      registerId={attributionRegisterId}
      capturedAt={basicData?.updated_at}
    />
  );
}
